(() => {
  if (!customElements.get('sfsc-quantity-choice')) {
    customElements.define('sfsc-quantity-choice', class extends HTMLElement {
      connectedCallback() {
        this.scope = document.getElementById('shopify-section-' + this.dataset.section);
        this.form = document.getElementById('product-form-' + this.dataset.section);
        this.native = this.scope?.querySelector('quantity-input input[name="quantity-js"]');
        if (!this.form || !this.native) return;
        this.prices = JSON.parse(this.querySelector('[data-quantity-prices]').textContent);
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'});
        this.nativeBlock = this.native.closest('.product-form-block');
        if (this.nativeBlock) this.nativeBlock.hidden = true;
        this.onOther = () => {
          if (this.nativeBlock) this.nativeBlock.hidden = false;
          this.native.focus();
        };
        this.querySelector('[data-other]').addEventListener('click', this.onOther);
        this.hidden = false;
        this.onChoose = event => {
          if (!event.target.matches('input[type="radio"]')) return;
          this.native.value = event.target.value;
          this.native.dispatchEvent(new Event('change', { bubbles: true }));
          const quantity = this.form.elements.namedItem('quantity');
          if (quantity) quantity.value = event.target.value;
          this.refresh();
        };
        this.refresh = () => {
          const value = Number(this.native.value);
          this.querySelectorAll('input[type="radio"]').forEach(input => input.checked = Number(input.value) === value);
          const plan = this.form.elements.namedItem('selling_plan');
          const subscription = Boolean(plan && plan.value);
          const variant = this.prices[this.form.elements.namedItem('id')?.value];
          this.querySelectorAll('[data-quantity-price]').forEach(row => {
            const unitPrice = subscription ? variant?.plans[plan.value] : variant?.price;
            row.hidden = !Number.isFinite(unitPrice);
            if (row.hidden) return;
            const count = Number(row.dataset.quantityPrice);
            const regular = row.querySelector('[data-regular]');
            const total = row.querySelector('[data-total]');
            const laundry = this.dataset.laundry === 'true';
            const repeatTotal = unitPrice * count;
            const offerTotal = laundry && this.dataset.automaticOffer === 'active' && !subscription && count >= 2 ? Math.round(repeatTotal * .9) : repeatTotal;
            regular.hidden = offerTotal >= variant.price * count;
            const regularText = this.money.format(variant.price * count / 100);
            const totalText = this.money.format(offerTotal / 100);
            if (regular.textContent !== regularText) regular.textContent = regularText;
            if (total.textContent !== totalText) total.textContent = totalText;
            const caption = row.parentElement.querySelector('[data-price-caption]');
            if (caption) {
              const words = subscription ? 'Per delivery · 15% subscription savings' : (laundry && this.dataset.automaticOffer === 'active' && count >= 2 ? '10% quantity savings' : 'One-time purchase');
              if (caption.textContent !== words) caption.textContent = words;
            }
            row.setAttribute('aria-label' , (subscription ? 'Subscription total ' : 'One-time total ') + totalText + (regular.hidden ? '' : ', regular price ' + regularText));
          });
          const text = subscription ? value + (this.dataset.laundry === 'true' ? ' per delivery. 15% subscription savings. Choose a delivery interval that matches how much you wash.' : ' per delivery. Uses your selected subscription schedule.') : value + ' in this one-time purchase. Use Add to Cart below.';
          const note = this.querySelector('[data-quantity-note]');
          if (note.textContent !== text) note.textContent = text;
        };
        this.addEventListener('change', this.onChoose);
        this.scope.addEventListener('change', this.refresh);
        this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 500);
        this.refresh();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.nativeBlock) this.nativeBlock.hidden = false;
        this.querySelector('[data-other]')?.removeEventListener('click', this.onOther);
        this.removeEventListener('change', this.onChoose);
        this.scope?.removeEventListener('change', this.refresh);
      }
    });
  }
  if (!customElements.get('sfsc-addon')) {
    customElements.define('sfsc-addon', class extends HTMLElement {
      connectedCallback() {
        this.disclose = event => {
          const summary = event.target.closest('summary');
          if (!summary || !this.contains(summary)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const details = summary.parentElement;
          details.open = !details.open;
          summary.setAttribute('aria-expanded', String(details.open));
        };
        this.addEventListener('click', this.disclose, true);
        this.select = this.querySelector('[data-variant]');
        this.button = this.querySelector('[data-add]');
        this.status = this.querySelector('[data-status]');
        if (!this.select?.value) return;
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'});
        this.update = () => {
          const option = this.select.selectedOptions?.[0];
          if (!option) return;
          this.querySelector('[data-price]').textContent = this.money.format(Number(option.dataset.price) / 100);
          const compare = this.querySelector('[data-compare]');
          compare.hidden = Number(option.dataset.compare) <= Number(option.dataset.price);
          compare.textContent = this.money.format(Number(option.dataset.compare) / 100);
          const photo = this.querySelector('[data-photo]');
          if (photo && option.dataset.image) photo.src = option.dataset.image;
          this.status.textContent = '';
        };
        this.add = async () => {
          if (this.pending) return;
          this.pending = true;
          this.button.disabled = true;
          this.select.disabled = true;
          this.button.textContent = 'Adding…';
          this.status.textContent = '';
          let added = false;
          try {
            const response = await fetch(this.dataset.root + 'cart/add.js', {
              method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
              body:JSON.stringify({items:[{id:Number(this.select.value),quantity:1}],sections:'cart-drawer'})
            });
            if (!response.ok) {
              const error = await response.json().catch(() => ({}));
              throw new Error(error.description || 'This option could not be added. Please try another.');
            }
            added = true;
            const data = await response.json();
            this.status.textContent = 'Added to your cart as a one-time purchase.';
            this.button.textContent = 'Added';
            if (window.eventBus?.emit && data.sections?.['cart-drawer']) {
              window.eventBus.emit('update:cart:drawer', data);
              window.eventBus.emit('open:cart:drawer');
            } else {
              window.location.assign(this.dataset.root + 'cart');
            }
          } catch (error) {
            if (added) {
              this.status.textContent = 'Added. Open your cart to review it.';
              window.location.assign(this.dataset.root + 'cart');
            } else {
              this.status.textContent = error instanceof TypeError ? 'We could not confirm the result. Check your cart before trying again.' : error.message;
            }
          } finally {
            this.pending = false;
            this.select.disabled = false;
            this.button.disabled = false;
            this.button.textContent = this.dataset.action;
          }
        };
        this.select.addEventListener('change', this.update);
        this.button.addEventListener('click', this.add);
        this.button.hidden = false;
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.disclose, true);
        this.select?.removeEventListener('change', this.update);
        this.button?.removeEventListener('click', this.add);
      }
    });
  }
})();
